module.exports = __webpack_public_path__ + "static/media/adult_workshop.fdc78f53.jpg";